import React from 'react';
import Lottie from 'react-lottie';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    link: {
        textDecoration: 'none',
        color: theme.palette.primary.main,
        fontWeight: 'bold',
    },
});

class Link extends React.Component {
    render () {
        const { animation, ...other } = this.props;
        const defaultOptions = {
            loop: true,
            autoplay: true, 
            animationData: require('../../static/animations/' + animation + '.json'),
        };
  
        return (
            <Lottie options={defaultOptions}
                isStopped={false}
                {...other}
                isPaused={false}/>
        );
    }
}

export default withStyles(styles)(Link);